import { loan_application } from '@axo/shared/data-access/types';
import { Broker } from '@axo/shared/data-access/types/broker';
import { getCountryOptions } from '../../../../utils/Finland/getCountryOptions';

export const TRUSTPILOT_LINK =
  'https://widget.trustpilot.com/trustbox-data/539adbd6dec7e10e686debee?businessUnitId=5d949991dff97e00014e194b&locale=fi-FI';

export const RATES = {
  MIN: 0.06,
} as const;

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const DEFAULT_LOAN_DURATION = 15;
export const DEFAULT_LOAN_AMOUNT = 40_000;
export const MAX_LOAN_DURATION = 15;
export const MIN_LOAN_AMOUNT = 500;
export const MAX_LOAN_AMOUNT = 70_000;

export const PHONE_REGEX = /^(04\d|050|0457)\d{4,8}$/;

type OptionList<T> = { value: T; text: string }[];

export const radioOptions = [
  { text: 'yes', value: 'Yes' },
  { text: 'no', value: 'No' },
];

export const initialPurposeOptions: OptionList<loan_application.Purpose> = [
  { text: 'yes', value: loan_application.Purpose.RefinancingLoan },
  { text: 'no', value: loan_application.Purpose.Other },
];

export const citizenshipOptions = getCountryOptions();

const axoEmploymentOptions: OptionList<loan_application.EmploymentStatus> = [
  {
    text: 'EmploymentStatus.Permanent',
    value: loan_application.EmploymentStatus.Permanent,
  },
  {
    text: 'EmploymentStatus.Temporary',
    value: loan_application.EmploymentStatus.Temporary,
  },
  {
    text: 'EmploymentStatus.Entrepreneur',
    value: loan_application.EmploymentStatus.Entrepreneur,
  },
  {
    text: 'EmploymentStatus.Pensioner',
    value: loan_application.EmploymentStatus.Pensioner,
  },
  {
    text: 'EmploymentStatus.Student',
    value: loan_application.EmploymentStatus.Student,
  },
  {
    text: 'EmploymentStatus.Unemployed',
    value: loan_application.EmploymentStatus.Unemployed,
  },
];
const zmartaEmploymentOptions: OptionList<loan_application.EmploymentStatus> = [
  {
    text: 'EmploymentStatus.Permanent',
    value: loan_application.EmploymentStatus.Permanent,
  },
  {
    text: 'EmploymentStatus.Entrepreneur',
    value: loan_application.EmploymentStatus.Entrepreneur,
  },
  {
    text: 'EmploymentStatus.Pensioner',
    value: loan_application.EmploymentStatus.Pensioner,
  },
  {
    text: 'EmploymentStatus.Unemployed',
    value: loan_application.EmploymentStatus.Unemployed,
  },
  {
    text: 'EmploymentStatus.Student',
    value: loan_application.EmploymentStatus.Student,
  },
  {
    text: 'EmploymentStatus.ParentalLeave',
    value: loan_application.EmploymentStatus.ParentalLeave,
  },
  {
    text: 'EmploymentStatus.Farmer',
    value: loan_application.EmploymentStatus.Farmer,
  },
  {
    text: 'EmploymentStatus.Temporary',
    value: loan_application.EmploymentStatus.Temporary,
  },
];

export const employmentOptions = {
  [Broker.Axo]: axoEmploymentOptions,
  [Broker.Zmarta]: zmartaEmploymentOptions,
};

export const employerIndustryOptions: OptionList<loan_application.EmployerIndustry> =
  [
    {
      value: loan_application.EmployerIndustry.EnergyAndWater,
      text: 'EmployerIndustry.EnergyAndWater',
    },
    {
      value: loan_application.EmployerIndustry.PublicAdmin,
      text: 'EmployerIndustry.PublicAdmin',
    },
    {
      value: loan_application.EmployerIndustry.Organizational,
      text: 'EmployerIndustry.Organizational',
    },
    {
      value: loan_application.EmployerIndustry.MiningAndForestry,
      text: 'EmployerIndustry.MiningAndForestry',
    },
    {
      value: loan_application.EmployerIndustry.Trade,
      text: 'EmployerIndustry.Trade',
    },
    {
      value: loan_application.EmployerIndustry.RealEstateAndRental,
      text: 'EmployerIndustry.RealEstateAndRental',
    },
    {
      value: loan_application.EmployerIndustry.Education,
      text: 'EmployerIndustry.Education',
    },
    {
      value: loan_application.EmployerIndustry.Transportation,
      text: 'EmployerIndustry.Transportation',
    },
    {
      value: loan_application.EmployerIndustry.NationalDefense,
      text: 'EmployerIndustry.NationalDefense',
    },
    {
      value: loan_application.EmployerIndustry.Agriculture,
      text: 'EmployerIndustry.Agriculture',
    },
    {
      value: loan_application.EmployerIndustry.Accommodation,
      text: 'EmployerIndustry.Accommodation',
    },
    {
      value: loan_application.EmployerIndustry.Forestry,
      text: 'EmployerIndustry.Forestry',
    },
    {
      value: loan_application.EmployerIndustry.Services,
      text: 'EmployerIndustry.Services',
    },
    {
      value: loan_application.EmployerIndustry.FinanceAndInsurance,
      text: 'EmployerIndustry.FinanceAndInsurance',
    },
    {
      value: loan_application.EmployerIndustry.Construction,
      text: 'EmployerIndustry.Construction',
    },
    {
      value: loan_application.EmployerIndustry.FoodAndBeverage,
      text: 'EmployerIndustry.FoodAndBeverage',
    },
    {
      value: loan_application.EmployerIndustry.CleaningServices,
      text: 'EmployerIndustry.CleaningServices',
    },
    {
      value: loan_application.EmployerIndustry.SocialServices,
      text: 'EmployerIndustry.SocialServices',
    },
    {
      value: loan_application.EmployerIndustry.ProtectionAndSecurity,
      text: 'EmployerIndustry.ProtectionAndSecurity',
    },
    {
      value: loan_application.EmployerIndustry.TechnicalServices,
      text: 'EmployerIndustry.TechnicalServices',
    },
    {
      value: loan_application.EmployerIndustry.Industrial,
      text: 'EmployerIndustry.Industrial',
    },
    {
      value: loan_application.EmployerIndustry.HealthServices,
      text: 'EmployerIndustry.HealthServices',
    },
    {
      value: loan_application.EmployerIndustry.IT,
      text: 'EmployerIndustry.IT',
    },
    {
      value: loan_application.EmployerIndustry.Unknown,
      text: 'EmployerIndustry.Unknown',
    },
    {
      value: loan_application.EmployerIndustry.Research,
      text: 'EmployerIndustry.Research',
    },
    {
      value: loan_application.EmployerIndustry.Religious,
      text: 'EmployerIndustry.Religious',
    },
    {
      value: loan_application.EmployerIndustry.RecreationAndCulture,
      text: 'EmployerIndustry.RecreationAndCulture',
    },
  ];

export const jobPositionOptions: OptionList<loan_application.JobPosition> = [
  {
    value: loan_application.JobPosition.Employee,
    text: 'JobPosition.Employee',
  },
  {
    value: loan_application.JobPosition.LowerLevel,
    text: 'JobPosition.LowerLevel',
  },
  {
    value: loan_application.JobPosition.SeniorLevel,
    text: 'JobPosition.SeniorLevel',
  },
  {
    value: loan_application.JobPosition.Management,
    text: 'JobPosition.Management',
  },
];

export const educationOptions: OptionList<loan_application.Education> = [
  {
    text: 'Education.ElementarySchool',
    value: loan_application.Education.EducationElementarySchool,
  },
  {
    text: 'Education.VocationalSchool',
    value: loan_application.Education.EducationVocationalSchool,
  },
  {
    text: 'Education.HighSchool',
    value: loan_application.Education.EducationHighSchool,
  },
  {
    text: 'Education.HigherEducation',
    value: loan_application.Education.EducationHigherEducation,
  },
];

export const maritalStatusOptions: OptionList<loan_application.MaritalStatus> =
  [
    {
      value: loan_application.MaritalStatus.Married,
      text: 'MaritalStatus.Married',
    },
    {
      value: loan_application.MaritalStatus.Single,
      text: 'MaritalStatus.Single',
    },
    {
      value: loan_application.MaritalStatus.Cohabiting,
      text: 'MaritalStatus.Cohabiting',
    },
  ];

export const amountOfChildrenOptions: OptionList<string> = [
  { value: '0', text: '0' },
  { value: '1', text: '1' },
  { value: '2', text: '2' },
  { value: '3', text: '3' },
  { value: '4', text: '4' },
  { value: '5', text: '5+' },
];

const axoHousingOptions: OptionList<loan_application.Residence> = [
  { value: loan_application.Residence.OwnHouse, text: 'HousingType.OwnHouse' },
  {
    value: loan_application.Residence.OwnApartment,
    text: 'HousingType.OwnApartment',
  },
  { value: loan_application.Residence.Rental, text: 'HousingType.Rental' },
  {
    value: loan_application.Residence.PartnersHouse,
    text: 'HousingType.PartnersHouse',
  },
  {
    value: loan_application.Residence.CompanyOwnedFlat,
    text: 'HousingType.CompanyOwnedFlat',
  },
  {
    value: loan_application.Residence.Cohabitant,
    text: 'HousingType.Cohabitant',
  },
];
const zmartaHousingOptions: OptionList<loan_application.Residence> = [
  ...axoHousingOptions,
  {
    value: loan_application.Residence.WithParents,
    text: 'HousingType.WithParents',
  },
];
export const housingOptions = {
  [Broker.Axo]: axoHousingOptions,
  [Broker.Zmarta]: zmartaHousingOptions,
};

export const debtCreditorsOptions: OptionList<string> = [
  {
    value: 'Aktia',
    text: 'Aktia',
  },
  {
    value: 'Danske',
    text: 'Danske',
  },
  {
    value: 'Handelsbanken',
    text: 'Handelsbanken',
  },
  {
    value: 'Hypoteekkiyhdistys',
    text: 'Hypoteekkiyhdistys',
  },
  {
    value: 'Nordea',
    text: 'Nordea',
  },
  {
    value: 'Oma säästöpankki',
    text: 'Oma säästöpankki',
  },
  {
    value: 'Osuuspankki',
    text: 'Osuuspankki',
  },
  {
    value: 'POP-Pankki',
    text: 'POP-Pankki',
  },
  {
    value: 'S-Pankki Oy',
    text: 'S-Pankki Oy',
  },
  {
    value: 'Säästöpankki',
    text: 'Säästöpankki',
  },
  {
    value: 'Ålandsbanken',
    text: 'Ålandsbanken',
  },
];

export const apartmentTypeOptions: OptionList<loan_application.ApartmentType> =
  [
    {
      value: loan_application.ApartmentType.ApartmentBuilding,
      text: 'ApartmentType.ApartmentBuilding',
    },
    {
      value: loan_application.ApartmentType.Townhouse,
      text: 'ApartmentType.Townhouse',
    },
    {
      value: loan_application.ApartmentType.DetachedHouse,
      text: 'ApartmentType.DetachedHouse',
    },
  ];

const axoPurposeOptions: OptionList<loan_application.Purpose> = [
  {
    value: loan_application.Purpose.RefinancingLoan,
    text: 'Purpose.RefinancingLoan',
  },
  {
    value: loan_application.Purpose.Renovation,
    text: 'Purpose.Renovation',
  },
  {
    value: loan_application.Purpose.Vehicle,
    text: 'Purpose.Vehicle',
  },
  {
    value: loan_application.Purpose.Other,
    text: 'Purpose.Other',
  },
];
const purposeOptionsZmarta: OptionList<loan_application.Purpose> = [
  {
    value: loan_application.Purpose.Housing,
    text: 'Purpose.Housing',
  },
  {
    value: loan_application.Purpose.Consumption,
    text: 'Purpose.Consumption',
  },
  {
    value: loan_application.Purpose.RefinancingLoan,
    text: 'Purpose.RefinancingLoan',
  },
  {
    value: loan_application.Purpose.Vehicle,
    text: 'Purpose.Vehicle',
  },
  {
    value: loan_application.Purpose.HomeInteriorDesign,
    text: 'Purpose.HomeInteriorDesign',
  },
  {
    value: loan_application.Purpose.Investment,
    text: 'Purpose.Investment',
  },
];

export const purposeOptions = {
  [Broker.Axo]: axoPurposeOptions,
  [Broker.Zmarta]: purposeOptionsZmarta,
};
